
export default {
  name: 'BaseUserConfirmEmailSendButton',
  data() {
    return {
      isSendConfirmEmail: false,
      error: null,
      isLoad: false,
    }
  },
  methods: {
    async sendConfirmEmail() {
      this.isLoad = true
      this.loginError = null
      this.passwordError = null
      this.emailError = null
      this.error = null
      this.isSendConfirmEmail = false
      try {
        await this.$axios.$post('/auth/confirm/email/send')
        this.isSendConfirmEmail = true
        this.isLoad = false
      } catch (err) {
        if (err.response?.data?.statusCode) {
          switch (err.response.data.statusCode) {
            // Нет пользователя (не залогинен)
            case 401:
              this.error = {
                status: 'error',
                message: err.response.data.message,
              }
              break

            // Если вдруг нераспознанная ошибка на сервере
            default:
              this.error = 'Что-то пошло не так...'
              break
          }
        }
      }
    },
  },
}
